/**
 * Picks v2 or v1 of the Subcategories page based on the redesign flag.
 * Same pattern as the other Switch components.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SubCategoryPage   from './SubCategoryPage';
import SubCategoryPageV2 from './SubCategoryPageV2';

export default function SubCategoryPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SubCategoryPageV2 : SubCategoryPage;
  return <Component {...props} />;
}
